/**
 * Resúmenes de ticket que significan «el último mensaje se borró». El backend guarda una marca
 * neutra (`backend/src/constants/lastMessage.ts`) y el panel la traduce; los dos textos en
 * portugués son los que se guardaban antes (doc 0449 §2.4) y pueden seguir en tickets viejos.
 */
export const LAST_MESSAGE_DELETED_MARKERS = ["[deleted]", "🚫 _Mensagem Apagada_", "Mensagem apagada"];
